(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 68:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ A; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/A/AStyle.ts



var AStyle = es/* StyleSheet.create */.mM.create({
  a: {
    textDecoration: "none",
    margin: 0,
    padding: 0,
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor
  },
  inline: {
    textDecoration: "underline",
    margin: 0,
    padding: 0,
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/A/A.tsx


var _excluded = ["styles", "children", "styleKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var A = function A(props) {
  var styles = props.styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "a" : _props$styleKey,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
    className: (0,es/* css */.iv)(AStyle[styleKey], styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 26919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ LiffTypes; }
/* harmony export */ });
var LiffTypes = {
  researchFlight: "researchFlight",
  researchHotel: "researchHotel",
  top: "top",
  lineEntry: "lineEntry"
};

/***/ }),

/***/ 39615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useUserSocialAutoSignIn; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95094);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12297);
/* harmony import */ var main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26919);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94265);








 // useSocialAutoSignInのredux toolkit版
// initializedとloggedInを分けて管理しているため注意
// LINEから着地するページで使う(useAccountとの違い)
// Login + initをしておく(Loginはcookieで次のページにも引き継がれる)

var useUserSocialAutoSignIn = function useUserSocialAutoSignIn(store, liffIdType, notIssueSession) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadedLIFF = _useState[0],
      setIsLoadedLIFF = _useState[1]; // const [isLoadedFBM, setIsLoadedFBM] = useState(false);


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoadedAccount = _useState2[0],
      setIsLoadedAccount = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLIFFInitializedState = _useState3[0],
      setIsLIFFInitializedState = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLIFFLoggedInState = _useState4[0],
      setIsLIFFLoggedInState = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isFacebookMessengerInitializedState // setIsFacebookMessengerInitializedState,
  = _useState5[0];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isFacebookMessengerLoggedInState // setIsFacebookMessengerLoggedInState,
  = _useState6[0];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      liffError = _useState7[0],
      setLiffError = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      facebookError // setFacebookError
  = _useState8[0];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      currentUser = _useState9[0],
      setCurrentUser = _useState9[1];

  var researchFlightLiffId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
  var researchHotelLiffId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
  var facebookAppId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");

  var onLoadScriptLIFF = function onLoadScriptLIFF() {
    var _liff;

    var context = (_liff = liff) === null || _liff === void 0 ? void 0 : _liff.getOS();

    if (context) {
      setIsLoadedLIFF(true);
    }
  }; // const onLoadScriptFBM = () => {
  //   setIsLoadedFBM(true);
  // };


  var loadScript = function loadScript(url, onload) {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = onload ? onload : null;
    document.body.appendChild(script);
  }; // LIFF IDが必要なためここでAccountParamsを取得する


  var loadAccount = /*#__PURE__*/function () {
    var _ref = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var param, t_session_id;
      return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              param = "";
              t_session_id = router.query.t_session_id;

              if (t_session_id) {
                param += "t_session_id=".concat(t_session_id);
              }

              if (notIssueSession && !t_session_id) {
                param += param === "" ? "" : "&";
                param += "not_issue_session=".concat(notIssueSession);
              }

              store.dispatch((0,main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_3__/* .fetchAccountParams */ .Nv)({
                param: param
              })).then(_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .unwrapResult */ .SI).then(function (result) {
                var accountParams = result;

                if (accountParams) {
                  var newCurrentUser = accountParams.currentUser;
                  setCurrentUser(newCurrentUser);
                  researchFlightLiffId.current = accountParams.researchFlightLiffId;
                  researchHotelLiffId.current = accountParams.researchHotelLiffId;
                  facebookAppId.current = accountParams.facebookAppId;
                  setIsLoadedAccount(true);
                }
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadAccount() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (router.isReady) {
      loadAccount()["catch"](function (e) {
        console.error(e);
      });
    }
  }, [router.isReady]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!isLoadedLIFF) {
      if (typeof liff === "undefined") {
        loadScript(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_2__/* .LINE_LIFF_SDK_URL */ .i3, onLoadScriptLIFF);
      } else {
        setIsLoadedLIFF(true);
      }
    } else {
      if (isLoadedAccount) {
        initLiff();
      }
    }
  }, [isLoadedLIFF, isLoadedAccount]); // FacebookMessengerは現在使用していない
  // useEffect(() => {
  //   // SDKが読み込まれた後でextAsyncInitを設定しても呼ばれないため
  //   // SDKがロード済みかどうか判定する必要がある
  //   if (!isLoadedFBM) {
  //     if (!(window as any).MessengerExtensions) {
  //       waitFacebookMessengerScriptLoaded();
  //       loadScript(FACEBOOK_MESSENGER_SDK_URL);
  //     } else {
  //       setIsLoadedFBM(true);
  //     }
  //   } else {
  //     if (isLoadedAccount) {
  //       initFacebookMessengerExtension();
  //     }
  //   }
  // }, [isLoadedFBM, isLoadedAccount]);
  // const initFacebookMessengerExtension = (): any => {
  //   console.log("initFacebookMessengerExtension");
  //   (window as any).MessengerExtensions.getContext(
  //     facebookAppId.current,
  //     (result: any): void => {
  //       store
  //         .dispatch(signInFacebookUser(result))
  //         .then(unwrapResult)
  //         .then(() => {
  //           store.dispatch(setIsFacebookMessengerLoggedIn(true));
  //           setIsFacebookMessengerLoggedInState(true);
  //         });
  //       store.dispatch(setIsFacebookMessengerInitialized(true));
  //       setIsFacebookMessengerInitializedState(true);
  //     },
  //     (err: any): void => {
  //       console.log("FBM ERROR ", err);
  //       setFacebookError(err);
  //     }
  //   );
  // };
  //
  // const waitFacebookMessengerScriptLoaded = (): any => {
  //   // console.log("waitFacebookMessengerScriptLoaded");
  //   (window as any).extAsyncInit = (): void => {
  //     // console.log(" extAsyncInit");
  //     // FBはscriptのonloadではなくextAsyncInitでload完了とみなす
  //     onLoadScriptFBM();
  //   };
  // };

  var getLiffId = function getLiffId() {
    if (liffIdType === main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_4__/* .LiffTypes.researchFlight */ .Y.researchFlight) {
      return researchFlightLiffId.current;
    } else if (liffIdType === main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_4__/* .LiffTypes.researchHotel */ .Y.researchHotel) {
      return researchHotelLiffId.current;
    } else if (liffIdType === main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_4__/* .LiffTypes.top */ .Y.top) {
      return main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_2__/* .TOP_LIFF_ID */ .oh;
    } else if (liffIdType === main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_4__/* .LiffTypes.lineEntry */ .Y.lineEntry) {
      return main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_2__/* .LINE_ENTRY_LIFF_ID */ .PS;
    }

    return null;
  };

  var initializeLIFFState = function initializeLIFFState() {
    store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsLIFFInitialized */ .hV)(true));
    setIsLIFFInitializedState(true);
  };

  var initLiff = function initLiff() {
    var liffId = getLiffId();

    if (!liffId) {
      return;
    } // store.dispatch(setIsLIFF(liff.isInClient())); // v2


    if (liff.id && liff.isLoggedIn()) {
      // すでに初期化済み
      store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsLIFFInitialized */ .hV)(true));
      store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsLIFFLoggedIn */ .ux)(true));
      setIsLIFFInitializedState(true);
      setIsLIFFLoggedInState(true);
      return;
    }

    liff.init({
      liffId: liffId
    }).then(function (_) {
      // Now you can call LIFF API
      var accessToken = liff.getAccessToken();
      console.log("accessToken: ".concat(accessToken));

      if (accessToken) {
        console.log("AccessToken: ", accessToken);
        console.log("CREATE_LINE_AUTO_SIGN_IN");
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__/* .signInLineUser */ .nl)({
          accessToken: accessToken
        })).then(_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .unwrapResult */ .SI).then(function () {
          // サインイン成功時initializedとloggedInは
          // 同時に設定されることを前提にしている
          initializeLIFFState();
          store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsLIFFLoggedIn */ .ux)(true));
          setIsLIFFLoggedInState(true);
        })["catch"](function () {
          // エラー時はinitializedのみ設定
          initializeLIFFState();
        });
      } else {
        // accessTokenが取得できない時もinitializedのみ設定
        initializeLIFFState();
      }
    }, function (err) {
      // LIFF initialization failed
      console.log("liff initialization failed", err);
      setLiffError(err);
    });
  };

  return [isLIFFInitializedState, isLIFFLoggedInState, isFacebookMessengerInitializedState, isFacebookMessengerLoggedInState, liffError, facebookError, isLoadedAccount, currentUser];
};

/***/ }),

/***/ 92119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6339);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79169);
/* harmony import */ var main_javascripts_containers_organisms_Header_HeaderContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12664);
/* harmony import */ var main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15305);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44349);
/* harmony import */ var main_javascripts_components_atoms_Block_MainBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59941);
/* harmony import */ var main_javascripts_components_head_MainHead__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65025);
/* harmony import */ var main_javascripts_components_search_SearchBlock__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44112);
/* harmony import */ var main_javascripts_components_organisms_Search_RecommendedInfo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66425);
/* harmony import */ var main_javascripts_hooks_common_useConstructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83795);
/* harmony import */ var main_javascripts_hooks_common_useUserSocialAutoSignIn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39615);
/* harmony import */ var main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26919);
/* harmony import */ var main_javascripts_features_search_components_CategoryTab__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8832);
/* harmony import */ var main_javascripts_features_search_components_Search__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93163);
/* harmony import */ var main_javascripts_features_search_searchPageSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54231);
/* harmony import */ var main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80264);
/* harmony import */ var main_javascripts_features_search_components_SearchChatEntry__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32915);
/* harmony import */ var main_javascripts_containers_organisms_Footer_FooterContainer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(98198);
/* harmony import */ var main_javascripts_features_post_components_PostIndexMain__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95742);
/* harmony import */ var main_javascripts_features_post_postSlice__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(78121);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(35944);


 // import { Store } from "redux";
















 // import { Footer } from "main/javascripts/components/footer/Footer";

 // import { loadVConsole } from "main/utils/DebugUtil";







// loadVConsole(2000);
function Index(props) {
  var locale = props.locale,
      origin = props.origin;
  var posts = props.posts,
      totalNum = props.totalNum,
      page = props.page,
      numPerPage = props.numPerPage,
      region = props.region,
      rankings = props.rankings,
      popularTags = props.popularTags,
      tag = props.tag;
  (0,main_javascripts_hooks_common_useConstructor__WEBPACK_IMPORTED_MODULE_10__/* .useConstructor */ .g)(function () {
    if (false) {}

    main_javascripts_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,main_javascripts_features_search_searchPageSlice__WEBPACK_IMPORTED_MODULE_15__/* .changeSearchCategory */ .xc)(main_javascripts_constants_SearchCategories__WEBPACK_IMPORTED_MODULE_16__/* .searchCategories.hotel */ .M.hotel));
    void i18n__WEBPACK_IMPORTED_MODULE_5__/* ["default"].changeLanguage */ .Z.changeLanguage(locale);
    main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_4__/* .extended.css */ .bU.css(main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_4__/* .defaultStyles */ .jF[main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_4__/* .GLOBALS */ .UH]);
  });
  (0,main_javascripts_hooks_common_useUserSocialAutoSignIn__WEBPACK_IMPORTED_MODULE_11__/* .useUserSocialAutoSignIn */ .X)(main_javascripts_store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h, main_javascripts_constants_LiffTypes__WEBPACK_IMPORTED_MODULE_12__/* .LiffTypes.top */ .Y.top);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (false) {}
  }, [posts, totalNum, page, numPerPage, tag]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, {
    store: main_javascripts_store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_components_head_MainHead__WEBPACK_IMPORTED_MODULE_7__/* .MainHead */ .I, {
      origin: origin
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(react_i18next__WEBPACK_IMPORTED_MODULE_22__/* .I18nextProvider */ .a, {
      i18n: i18n__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_containers_organisms_Header_HeaderContainer__WEBPACK_IMPORTED_MODULE_3__/* .HeaderContainer */ .g, {}, 0), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_components_atoms_Block_MainBlock__WEBPACK_IMPORTED_MODULE_6__/* .MainBlock */ .R, {
          children:  false ? 0 : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(main_javascripts_components_search_SearchBlock__WEBPACK_IMPORTED_MODULE_8__/* .SearchBlock */ .w, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_features_search_components_CategoryTab__WEBPACK_IMPORTED_MODULE_13__/* .CategoryTab */ .C, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_features_search_components_Search__WEBPACK_IMPORTED_MODULE_14__/* .Search */ .o, {})]
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_features_search_components_SearchChatEntry__WEBPACK_IMPORTED_MODULE_17__/* .SearchChatEntry */ .y, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_components_organisms_Search_RecommendedInfo__WEBPACK_IMPORTED_MODULE_9__/* .RecommendedInfo */ .A, {})]
          })
        }, 1), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(main_javascripts_containers_organisms_Footer_FooterContainer__WEBPACK_IMPORTED_MODULE_18__/* .FooterContainer */ .b, {}, 3)]
      })
    })]
  });
}

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92119);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8053,9481,9113,5057,1906,2912,9923,4170,4602,2802,853,7744,8808,7886,4349,6129,8740,5147,4750,1185,5567,5284,6852,5543,2582,8452,9938,2867,5219,652,831,9926,3272,5624,2049,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);